// Función para enviar una solicitud POST con los datos de la visita
function sendVisit(type) { 
    // Datos de la visita a enviar
    var visitData = {
      user: getCookie('ualk'),
      session:  getCookie('PHPSESSID'), 
      refdata: getCookie('refdata'), 
      isMovil: _FROM_MOVIL,
      page : window.location.origin + window.location.pathname,
      type : type
    };
    
    const formData = new FormData();

    for (let key in visitData) {
        formData.append(key, visitData[key]);
    }
  
    // Enviar la solicitud POST al servidor
    fetch('/action/page', {
        method: 'POST',
        body: formData
    }).then(response => response.json())
    .then(data => {
            //console.log(data);
    })
    .catch(function(error) {}); 
}


function getCookie(name) {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
  
      if (cookie.startsWith(name + '=')) {
        const cookieValue = cookie.substring(name.length + 1);
        return decodeURIComponent(cookieValue);
      }
    }
  
    return null;
}

// Función para iniciar la sesión
function initVisit() {
    sendVisit('start');
}

// Función para finalizar la sesión y enviar los datos
function endSession() {
    sendVisit('end');
}


if (!window.location.pathname.includes("widget")) {
  // Llamar a la función startSession al cargar la página
  initVisit();

  // Llamar a la función endSession cuando el usuario abandona la página o realiza una acción específica
  window.addEventListener('beforeunload', endSession);
}

